import { render, staticRenderFns } from "./TheGratis.vue?vue&type=template&id=11f40159&scoped=true&"
import script from "./TheGratis.vue?vue&type=script&lang=js&"
export * from "./TheGratis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f40159",
  null
  
)

export default component.exports